import React, { Dispatch, useEffect } from "react";
import { getProfileDetails } from "../api/utils/api";
import { GetApplicationType, GetProfileType } from "../api/schemas/schema";
import { BreadCrumbsKeysType } from "../hooks/useBreadcrumb";
import useSnackBar from "../components/common/general/SnackBar";
import useCleverTap from "../clevertap/useCleverTap";

export interface ApplicationState {
  applicationData?: GetApplicationType | null;
  profileData?: GetProfileType | null;
  breadcrumb?: BreadCrumbsKeysType[] | null;
  fetchApplicationData?: boolean;
  fetchProfileData?: boolean;
  showGuidedTour?: boolean;
  isScholar?: boolean;
}
const initState: ApplicationState = {
  applicationData: null,
  profileData: null,
  breadcrumb: null,
  fetchApplicationData: true,
  fetchProfileData: false,
  showGuidedTour: false,
  isScholar: undefined,
};

export enum ApplicationActionType {
  SET_BREADCRUMBS,
  SET_PROFILE,
  SET_APPLICATION,
  FETCH_APPLICATION,
  FETCH_PROFILE,
  SET_GUIDED_TOUR,
  SET_SCHOLAR_STATUS,
}
export interface AppContextActions {
  type: ApplicationActionType;
  payload: ApplicationState;
}

const reducer = (state: ApplicationState, action: AppContextActions) => {
  switch (action.type) {
    case ApplicationActionType.SET_BREADCRUMBS: {
      return {
        ...state,
        breadcrumb: action.payload.breadcrumb,
      };
    }
    case ApplicationActionType.SET_PROFILE: {
      return {
        ...state,
        profileData: action.payload.profileData,
        fetchProfileData: false,
      };
    }
    case ApplicationActionType.SET_APPLICATION: {
      return {
        ...state,
        applicationData: action.payload.applicationData,
        fetchApplicationData: false,
      };
    }
    case ApplicationActionType.FETCH_APPLICATION: {
      return {
        ...state,
        fetchApplicationData: true,
      };
    }
    case ApplicationActionType.FETCH_PROFILE: {
      return {
        ...state,
        fetchProfileData: true,
      };
    }
    case ApplicationActionType.SET_GUIDED_TOUR: {
      return {
        ...state,
        showGuidedTour: action.payload.showGuidedTour,
      };
    }
    case ApplicationActionType.SET_SCHOLAR_STATUS: {
      return {
        ...state,
        isScholar: action.payload.isScholar,
      };
    }
    default:
      return state;
  }
};

export const AppContext = React.createContext<[ApplicationState, Dispatch<AppContextActions>]>([
  initState,
  () => null,
]);

interface Props {
  children: JSX.Element | JSX.Element[];
}

const ApplicationContextProvider = (props: Props) => {
  const [state, dispatch] = React.useReducer(reducer, initState);
  const snackbar = useSnackBar();
  const cleveratp = useCleverTap()[0];

  const fetchProfile = React.useCallback(() => {
    getProfileDetails()
      .then((res) => {
        // cleveratp.onUserLogin({
        //   Name: res.name,
        //   Identity: res.slug,
        //   Email: res.email,
        //   Phone: res.phone_number,
        //   Gender: res.gender,
        //   DOB: res.date_of_birth ? new Date(res.date_of_birth) : undefined,
        //   "MSG-email": !!res.email_updates,
        //   "MSG-whatsapp": !!res.whatsapp_updates,
        // });
        dispatch({
          type: ApplicationActionType.SET_PROFILE,
          payload: {
            profileData: res,
          },
        });
      })
      .catch((err) => {
        //
      });
  }, []);

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    if (state.fetchProfileData) {
      fetchProfile();
    }
  }, [state.fetchProfileData]);

  return <AppContext.Provider value={[state, dispatch]}>{props.children}</AppContext.Provider>;
};

export default ApplicationContextProvider;
